// eslint-disable-next-line max-classes-per-file
import {
  IsEnum,
  IsArray,
  IsString,
  IsBoolean,
  IsNotEmpty,
  IsOptional,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { AttachmentItem } from '@app/gen/news';

class AnswerTextSettingsDto {
  @IsString({ message: 'Обязательное поле' })
  @IsOptional()
  minLength?: string;

  @IsString({ message: 'Обязательное поле' })
  @IsOptional()
  maxLength?: string;

  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  textLimit: boolean;
}

class AnswerOptionDto {
  @IsString({ message: 'Обязательное поле' })
  @IsNotEmpty({ message: 'Обязательное поле' })
  id: string;

  @IsString({ message: 'Обязательное поле' })
  @IsNotEmpty({ message: 'Обязательное поле' })
  content: string;
}

export class AnswerSettingsDto {
  @IsString({ message: 'Обязательное поле' })
  @IsNotEmpty({ message: 'Обязательное поле' })
  id: string;

  @IsEnum(['one', 'several', 'text'])
  @IsNotEmpty()
  type: 'one' | 'several' | 'text';

  @ValidateNested({ each: true })
  @ValidateIf((o) => o.type === 'one' || o.type === 'several')
  @Type(() => AnswerOptionDto)
  @IsArray()
  @IsOptional()
  answers?: AnswerOptionDto[];

  @ValidateNested()
  @ValidateIf((o) => o.type === 'text')
  @Type(() => AnswerTextSettingsDto)
  @IsOptional()
  answer?: AnswerTextSettingsDto;
}

class FormContentDto {
  @IsString()
  @IsNotEmpty()
  data: string;

  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  hasContent: boolean;

  @ValidateNested({ each: true })
  @Type(() => AttachmentItem)
  @IsArray()
  @IsOptional()
  attachments?: AttachmentItem[];
}

export class FormQuestionsSectionDto {
  @IsString()
  @IsOptional()
  id?: string;

  @Type(() => FormContentDto)
  @IsNotEmpty({ message: 'Обязательное поле' })
  content: FormContentDto;

  @ValidateNested({ each: true })
  @Type(() => AnswerSettingsDto)
  @IsArray()
  @IsNotEmpty()
  answerSettings: AnswerSettingsDto[];
}
